import { css } from '@fable/theme'
import { FlexBox, Text } from '@fable/components'
import { StreakMapChart } from './StreakMapChart'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const StreakMapChartContent = () => {
  const theme = useStatsTheme((s) => s.theme)
  const mapColors = theme.colors.charts.streakMap

  const months = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']

  const legend = [
    {
      color: mapColors.bestStreak,
      label: 'Best streak',
    },
    {
      color: mapColors.daysRead,
      label: 'Days Read',
    },
    {
      color: mapColors.finished,
      label: 'Finished',
    },
  ]

  return (
    <div
      className={css`
        padding: 16px 0 10px;
        width: 100%;
        position: relative;
      `}
    >
      <div
        className={css`
          width: 100%;
        `}
      >
        <div
          className={css`
            width: 100%;
          `}
        >
          <StreakMapChart />
          <FlexBox
            className={css`
              padding-top: 6px;
              width: 100%;
            `}
            justifyContent="space-between"
            alignItems="center"
          >
            {months.map((m, i) => (
              <FlexBox
                key={i}
                className={css`
                  gap: 4px;
                  width: 24px;
                `}
                flexDirection="column"
              >
                <span
                  className={css`
                    display: block;
                    width: 1px;
                    height: 2px;
                    background-color: ${theme.colors.section.textSecondary};
                  `}
                />
                <Text
                  type="body"
                  className={css`
                    font-size: 8px;
                    line-height: 8px;
                  `}
                  color={theme.colors.section.textSecondary}
                >
                  {m}
                </Text>
              </FlexBox>
            ))}
          </FlexBox>
        </div>
      </div>
      <FlexBox
        className={css`
          padding: 25px 0 0;
          width: 100%;
          gap: 5%;
        `}
        alignItems="center"
      >
        {legend.map(({ color, label }) => (
          <FlexBox
            key={label}
            className={css`
              gap: 4px;
            `}
            flexDirection="column"
          >
            <span
              className={css`
                display: block;
                width: 12px;
                height: 12px;
                background-color: ${color};
                border-radius: 4px;
              `}
            />
            <Text
              className={css`
                font-size: 10px;
                line-height: 12px;
                letter-spacing: -0.2px;
              `}
              type="body"
              weight="500"
              color={theme.colors.section.legend.text}
            >
              {label}
            </Text>
          </FlexBox>
        ))}
      </FlexBox>
    </div>
  )
}
